import { render, staticRenderFns } from "./NonCat.vue?vue&type=template&id=3941bab8&scoped=true&"
import script from "./NonCat.vue?vue&type=script&lang=js&"
export * from "./NonCat.vue?vue&type=script&lang=js&"
import style0 from "./NonCat.vue?vue&type=style&index=0&id=3941bab8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3941bab8",
  null
  
)

export default component.exports